import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import { Column } from '../SharedStyles'
import { Gallery, TireHeader, Details } from './components'
import { PRODUCT_DETAILS_SCHEMA_ID } from 'constant'

const BOTTireLineDetails = ({
  brandDetailsUrl,
  tireLineDetails: {
    benefits = [],
    features,
    description,
    imageSetPath,
    productName,
    bvId,
    productPrice,
    brandLogo,
    productDetails = '',
    revCount,
    isSpecialOrder,
    brandName = '',
    mainImageUrl = '',
    productId = '',
    brandPromisePlan
  } = {},
  hasActiveVehicle,
  offers = undefined,
  aggregateRating = undefined,
  review = undefined,
  tireLineDescription = undefined,
  itemMinPrice = '',
  itemMaxPrice = '',
  schemaUrl
}) =>
  <Wrapper>
    <Helmet>
      <script nonce={ window.BOT_NONCE } type="application/ld+json" id={ PRODUCT_DETAILS_SCHEMA_ID }>
        {
          JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            brand: brandName,
            name: productName,
            url: schemaUrl,
            description: tireLineDescription,
            sku: productId,
            gtin12: '', // In future sprints add UPC value to the schema when we can receive it from the BE.
            image: mainImageUrl,
            offers,
            aggregateRating,
            review
          })
        }
      </script>
    </Helmet>
    <Media.Desktop>
      <Column responsive>
        <Gallery data-at-tireline-gallery-container imageSetPath={ imageSetPath } />
      </Column>
      <Column responsive padding_desktop="0 50px 0 24px">
        <TireHeader
          productName={ productName }
          brandDetailsUrl={ brandDetailsUrl }
          bvId={ bvId }
          brandLogo={ brandLogo }
          revCount={ revCount }
          isSpecialOrder={ isSpecialOrder } />
        <Details
          hasActiveVehicle={ hasActiveVehicle }
          benefits={ benefits }
          features={ features }
          description={ description }
          productDetails={ productDetails }
          productPrice={ productPrice }
          itemMinPrice={ itemMinPrice }
          itemMaxPrice={ itemMaxPrice }
          brandPromisePlan={ brandPromisePlan } />
      </Column>
    </Media.Desktop>
    <Media.Mobile>
      <MobileWrapper>
        <TireHeader
          productName={ productName }
          brandDetailsUrl={ brandDetailsUrl }
          brandLogo={ brandLogo }
          bvId={ bvId }
          revCount={ revCount }
          isSpecialOrder={ isSpecialOrder } />
        <Gallery imageSetPath={ imageSetPath } />
        <Details
          hasActiveVehicle={ hasActiveVehicle }
          benefits={ benefits }
          features={ features }
          description={ description }
          productDetails={ productDetails }
          productPrice={ productPrice }
          itemMinPrice={ itemMinPrice }
          itemMaxPrice={ itemMaxPrice }
          brandPromisePlan={ brandPromisePlan } />
      </MobileWrapper>
    </Media.Mobile>
  </Wrapper>

BOTTireLineDetails.propTypes = {
  aggregateRating: PropTypes.shape({}),
  brandDetailsUrl: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  itemMaxPrice: PropTypes.number,
  itemMinPrice: PropTypes.number,
  offers: PropTypes.shape({}),
  review: PropTypes.arrayOf(),
  schemaUrl: PropTypes.string,
  tireLineDescription: PropTypes.string,
  tireLineDetails: PropTypes.shape({
    benefits: PropTypes.arrayOf(PropTypes.string),
    brandId: PropTypes.string,
    brandName: PropTypes.string,
    brandPromisePlan: PropTypes.string,
    bvId: PropTypes.string,
    description: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string),
    mainImageUrl: PropTypes.string,
    productDisplayName: PropTypes.string,
    productId: PropTypes.string,
    productName: PropTypes.string,
    productPrice: PropTypes.string
  })
}


export default BOTTireLineDetails

const Wrapper = styled.div`
  margin: 30px auto;
`

const MobileWrapper = styled.div`
  padding: 0 16px;
`
